import React from 'react';

import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';

import { IconButton } from '@/shared/ui/IconButton';

import styles from './LineageControls.module.css';

type LineageControlsProps = {
  isFullscreen: boolean;
  onToggleFullscreen: () => void;
};

export const LineageControls: React.FC<LineageControlsProps> = ({ isFullscreen, onToggleFullscreen }) => {
  return (
    <div className={styles.controls}>
      <div className={styles.rightSection}>
        <IconButton onClick={onToggleFullscreen} tooltip={isFullscreen ? '전체 화면 종료' : '전체 화면'}>
          {isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
        </IconButton>
      </div>
    </div>
  );
};
